import {Injectable} from '@angular/core';


declare let _: any;


@Injectable({
  providedIn: 'root'
})
export class CacheService{
    cacheMap: Map<string, Array<any>>;
    storeMap: Map<string, string>;

    initCache(){
        if (!this.cacheMap){
            this.cacheMap = new Map();
        }
        if (!this.storeMap){
            this.storeMap = new Map();
        }
    }

    insertCache(conversationId, data){
        if (this.cacheMap.size == 0){
            this.cacheMap.set(conversationId, data);
        }else {
            const cacheData = this.cacheMap.get(conversationId);
            if (!cacheData){
                this.cacheMap.set(conversationId, data);
            }
        }
    }

    getCacheData(conversationId){
        return this.cacheMap.get(conversationId);
    }

    updateCacheData(conversationId, latestData){
        let data = this.cacheMap.get(conversationId);
        if (data){
            data.push(latestData);
            data = _.uniqBy(data, 'id');
            this.cacheMap.set(conversationId, data);
        }
    }

    removeMessageFromCache(conversationId, messageId){
        const data = this.cacheMap.get(conversationId);
        if (data && data.length > 0){
            _.remove(data, {id: messageId});
        }
    }

    updateMessageFromCache(conversationId, latestData){
        const data = this.cacheMap.get(conversationId);
        if (data && data.length > 0){
            const index = _.findIndex(data, function(o) { return o.id == latestData.id; });
            if (index != -1){
                data[index] = latestData;
            }
        }
    }

    removeCache(){
        // this.cacheMap=null;
        this.cacheMap = new Map();
    }

    insertStoreCache(conversationId, message) {
        this.storeMap.set(conversationId, message);
    }

    removeStoreCache(conversationId) {
        this.storeMap.delete(conversationId);
    }
    clearCompanyCache(companyId){
    this.cacheMap.delete(companyId);
  }
}
